import { useAsyncData, useRouteLocationWithLocale } from '#imports'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import type { SearchPopularHit } from '~/api/search/types'
import { ROUTES as PRODUCT_LIST_ROUTES } from '~/scopes/product-list/route-names'

export function useFetchPopularSearches() {
  const resolveLocalizedRoute = useRouteLocationWithLocale()
  const $httpFetch = useHttpFetch()

  return useAsyncData(
    'searchbar-popular-searches',
    () => $httpFetch('/bm/search/v3/popular'),
    {
      default: () => [],
      lazy: true,
      transform: (data: SearchPopularHit[]) => {
        return data
          .filter(
            ({ link }) =>
              !(link.type === 'internal' && link.params.slugV2 === undefined),
          )
          .map(({ highlightedTitle, title, landingId: id, link }) => ({
            highlightedTitle,
            title,
            id,
            url:
              link.type === 'external'
                ? link.href
                : resolveLocalizedRoute({
                    name: PRODUCT_LIST_ROUTES.PRODUCT_LIST,
                    params: {
                      slugV2: link.params.slugV2,
                      uuid: id,
                    },
                  }),
          }))
      },
    },
  )
}
